import {
  GET_STORES,
  GET_STORES_SUCCESS,
  GET_STORES_FAILURE,
  GET_STORE_BY_URL_PATH,
  GET_STORE_BY_URL_PATH_SUCCESS,
  GET_STORE_BY_URL_PATH_FAILURE,
  GET_USER_LOCATION,
  GET_USER_LOCATION_SUCCESS,
  GET_USER_LOCATION_FAILURE,
  GET_LOCKERS_LIST,
  GET_LOCKERS_LIST_SUCCESS,
  GET_LOCKERS_LIST_FAILURE,
} from "@store/stores/constants";

import { makeApiCall } from "@lib/api/helpers";
import { getStoresApi, getStoreByUrlPathApi, getLockersApi } from "@lib/api";

import { getBrowserGeolocation } from "@lib/helpers";

export const getStores = () => (dispatch, getState) => {
  return makeApiCall({
    actions: {
      action: GET_STORES,
      success: GET_STORES_SUCCESS,
      fail: GET_STORES_FAILURE,
    },

    dispatch,
    getState,
    spinner: false,
    // spinnerMessage: "Loading stores list",
    alert: false,
    // alertMessage: `Get stores couldn't be completed...`,

    apiCall: getStoresApi,
    apiArgs: [],

    formatResponse: (response) => response.data.stores,
  });
};

export const getStoreByUrlPath = (urlPath) => (dispatch, getState) => {
  return makeApiCall({
    actions: {
      action: GET_STORE_BY_URL_PATH,
      success: GET_STORE_BY_URL_PATH_SUCCESS,
      fail: GET_STORE_BY_URL_PATH_FAILURE,
    },

    dispatch,
    getState,
    spinner: false,
    spinnerMessage: `Se incarca lista magazinelor`,
    alert: false,
    // alertMessage: `Get stores couldn't be completed...`,

    apiCall: getStoreByUrlPathApi,
    apiArgs: [encodeURIComponent(urlPath)],

    formatResponse: (response) => {
      return {
        store: response.data.stores[0],
      };
    },
  });
};

export const getUserLocation = () => (dispatch) => {
  // Dispatch get user location action
  dispatch({
    type: GET_USER_LOCATION,
  });

  // Check if browser has geolocation support and is enabled
  getBrowserGeolocation()
    .then((result) => {
      dispatch({
        type: GET_USER_LOCATION_SUCCESS,
        payload: result,
      });
    })
    .catch((error) => {
      // Catch error and dispatch get user location failure
      dispatch({
        type: GET_USER_LOCATION_FAILURE,
        error: error.message,
      });
    });
};

export const getLockersList = () => (dispatch, getState) => {
  return makeApiCall({
    actions: {
      action: GET_LOCKERS_LIST,
      success: GET_LOCKERS_LIST_SUCCESS,
      fail: GET_LOCKERS_LIST_FAILURE,
    },
    dispatch,
    getState,
    spinner: false,
    alert: false,
    apiCall: getLockersApi,
    apiArgs: [],

    formatResponse: (response) => response.data.data.lockers,
  });
};
